import { Box, Text } from '@chakra-ui/react';

interface RangeDotProps {
  position: string;
  color?: string;
  label: string;
  labelMargin?: number | null;
  zIndex?: number;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  testId?: string;
}

export const RangeDot = ({
  position,
  color = 'gray.400',
  label,
  labelMargin = null,
  zIndex = 1,
  onClick,
  onMouseEnter,
  onMouseLeave,
  testId,
}: RangeDotProps) => {
  return (
    <>
      <Box
        _after={{
          position: 'absolute',
          content: '""',
          borderLeft: `${labelMargin ? '12px' : '8px'} solid transparent`,
          borderRight: `${labelMargin ? '0px' : '8px'} solid transparent`,
          borderTop: '8px solid',
          borderTopColor: color,
          left: labelMargin ? '85%' : '50%',
          transform: 'translate(-50%, 0)',
          transition: 'left 0.3s ease-in-out',
          zIndex: 2,
        }}
        background={color}
        borderRadius="3px"
        bottom="26px"
        data-testid={testId}
        left={
          (labelMargin || 0) < 0
            ? `calc(${position} + ${labelMargin}px)`
            : position
        }
        position="absolute"
        px={1}
        transform={(labelMargin || 0) < 0 ? undefined : 'translateX(-50%)'}
        transition="left 0.3s ease-in-out"
        zIndex={zIndex}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <Text
          color="indigo.900"
          fontSize={{ base: 'sm', md: 'md' }}
          fontWeight="medium"
        >
          {label}
        </Text>
      </Box>
      <Box
        background={color}
        borderRadius="full"
        boxSize="16px"
        left={position}
        position="absolute"
        transform="translateX(-50%)"
        transition="left 0.3s ease-in-out"
        zIndex={zIndex + 1}
      />
    </>
  );
};
